//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { PojoSet } from 'pojo-sets';
import { createSelector } from 'reselect';

import { ICuralateStore } from '@models/AppState';
import ReelId from '@models/ReelId';

export const getAreNoGalleriesSelectedImpl = (
  gallerySelection: PojoSet<ReelId>,
) => {
  const selectedGalleryCount = PojoSet.size(gallerySelection);
  return selectedGalleryCount === 0;
};

export const getAreNoGalleriesSelected = createSelector(
  (state: ICuralateStore) =>
    state.galleries.addToGalleriesModal.gallerySelection,
  getAreNoGalleriesSelectedImpl,
);

export default getAreNoGalleriesSelected;
